import { TokenServiceClient } from '@johnlewispartnership/wtr-website-authentication/dist/service';
import config from 'config';
import getApiBaseUrl from 'utils/getApiBaseUrl';

export default new TokenServiceClient(getApiBaseUrl(config.services.tokenClient.path));
